import React, { useState } from 'react';
import { AiFillEdit, AiFillDelete } from 'react-icons/ai';
import FormulaireVue from './FormulaireVue/FormulaireVue';
import FormulaireCouche from './FormulaireCouche/FormulaireCouche';
import FormulaireObjetsAssocieVue from './FormulaireObjetsAssocieVue/FormulaireObjetsAssocieVue';
import AffichageVue from '../AffichageVue/AffichageVue';
import Popup from '../../UI/PopupVue/Popup';
import Bouton from '../../UI/Bouton/Bouton';
import AccesRestreins from '../../../hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import Collapse from '../../../hoc/Collapse/Collapse';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import { confirmeOnClick } from '../../../ressources/functionJS/confirmeOnClick';
import styles from './ProfilVue.module.scss';
import { useHistory } from 'react-router-dom';
import { deleteTask, getTasksFromViewPlanning } from 'services/api';
const ProfilVue = ({ infoVue, reqSupprimer }) => {
  const history = useHistory();
  const [afficherModifierVue, setAfficherModifierVue] = useState(false);

  const afficherModifierProfil = () => {
    setAfficherModifierVue(true);
  };

  const annulerModificationProfil = () => {
    setAfficherModifierVue(false);
  };

  const renderFormulaireVue = () => (
    <div>
      <div>
        <FormulaireVue
          affichageProfil={!afficherModifierVue}
          view_id={infoVue.view_id}
          preconfigurerVue={infoVue}
          annuler={annulerModificationProfil}
        />
        {!afficherModifierVue && (
          <div className={[styles.bts].join(' ')}>
            <AccesRestreins numPrivilege={privilege.modifier_des_vues}>
              <div className={styles.sas}>
                <Bouton cliquer={afficherModifierProfil}>
                  <AiFillEdit /> {checkMot('modifier')}
                </Bouton>
              </div>
            </AccesRestreins>
            <div className={styles.sas}>
              <AccesRestreins numPrivilege={privilege.supprimer_des_vues}>
                <AttenteRequete request_type={requestType.supprimer_une_vue}>
                  {infoVue.view_type !== 0 && infoVue.view_type !== 1 ? (
                    <Bouton
                      cliquer={() => {
                        confirmeOnClick(
                          checkMot('voulez_vous_vraiment_supprimer_cette_vue'),
                          () => {
                            getTasksFromViewPlanning({
                              viewId: infoVue.view_id,
                            })
                              .then((response) => {
                                const tasks = response.data.tasks;
                                const deletePromises = tasks.map((task) =>
                                  deleteTask({ taskId: task.task_id })
                                );
                                return Promise.all(deletePromises).then(() => {
                                  reqSupprimer(infoVue.view_id);
                                });
                              })
                              .catch((error) => {
                                console.error(
                                  'Error deleting tasks or view:',
                                  error
                                );
                              });
                          }
                        );
                      }}
                    >
                      <AiFillDelete /> {checkMot('supprimer')}
                    </Bouton>
                  ) : (
                    <Bouton
                      cliquer={() => {
                        confirmeOnClick(
                          checkMot('voulez_vous_vraiment_supprimer_cette_vue'),
                          () => reqSupprimer(infoVue.view_id)
                        );
                      }}
                    >
                      <AiFillDelete /> {checkMot('supprimer')}
                    </Bouton>
                  )}
                </AttenteRequete>
              </AccesRestreins>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const renderFormulaireCouches = () => (
    <div>
      <div>
        <FormulaireCouche view_id={infoVue.view_id} />
      </div>
    </div>
  );

  const renderFormulaireObjetsAssocieVue = () => (
    <div>
      <div>
        <FormulaireObjetsAssocieVue view_id={infoVue.view_id} />
      </div>
    </div>
  );
  const redirect = (type) => {
    if (type === 6 || type === 5) {
      history.push({
        pathname: `/planning/${infoVue.view_id}`,
        state: { infoVue: infoVue },
      });
    }
  };

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[styles.hedes].join(' ')}>
        <span className={styles.style}>
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            className="bi bi-info-circle-fill"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            />
          </svg>
        </span>
        <span className={styles.style}>
          {checkMot('vue_id')} : {infoVue.view_id}
        </span>
        <span className={styles.style}>
          {infoVue.view_type === 6 && (
            <button style={{ display: 'block' }} onClick={() => redirect(6)}>
              Afficher planning basevie
            </button>
          )}
          {infoVue.view_type === 5 && (
            <button onClick={() => redirect(5)}>
              Afficher planning electrovanne
            </button>
          )}
          {infoVue.view_type !== 6 && infoVue.view_type !== 5 && (
            <Popup hideHeader={true} texte_ouverture={'Afficher_vue'}>
              <AffichageVue
                view_id={infoVue.view_id}
                uniciteVue={checkMot('profil_vue')}
              />
            </Popup>
          )}
        </span>
      </div>
      <div className={[styles.newStyle].join(' ')}>
        <Collapse expandText={checkMot('info_general')}>
          {renderFormulaireVue()}
        </Collapse>
        {infoVue.view_type !== 6 && infoVue.view_type !== 5 && (
          <>
            <Collapse expandText={checkMot('couches')}>
              {renderFormulaireCouches()}
            </Collapse>
            <Collapse expandText={checkMot('objets')}>
              {renderFormulaireObjetsAssocieVue()}
            </Collapse>
          </>
        )}
      </div>
    </div>
  );
};

export default ProfilVue;
